import isSameDay from "date-fns/isSameDay";
import { formatDateTime, formatTime } from "utils/localizations";
import SystemComponentCode from "entities/systemComponentCode";
import OutageState from "entities/outageState";

export interface IOutage {
  visibleSince: Date;
  validSince: Date;
  validUntil?: Date;
  _validSinceTime?: string;
  _validUntilTime?: string;
  _visibleSinceTime?: string;
}

export function getOutageMessage(outage: IOutage, message: string) {
  if (outage.validUntil) {
    const timeDateValidUntil = new Date(outage.validUntil);
    if (outage._validUntilTime) {
      const [hours, minutes, seconds] = outage._validUntilTime.split(":");
      timeDateValidUntil.setHours(parseInt(hours, 10));
      timeDateValidUntil.setMinutes(parseInt(minutes, 10));
      timeDateValidUntil.setSeconds(parseInt(seconds, 10));
    }
    const sameDay = isSameDay(outage.validUntil, outage.validSince);
    message = message.replace(
      /%validUntil%/g,
      sameDay && outage.validSince > new Date() ? formatTime(timeDateValidUntil) : formatDateTime(timeDateValidUntil)
    );
  }
  const timeDateValidSince = new Date(outage.validSince);
  if (outage.validSince && outage._validSinceTime) {
    const [hours, minutes, seconds] = outage._validSinceTime.split(":");
    timeDateValidSince.setHours(parseInt(hours, 10));
    timeDateValidSince.setMinutes(parseInt(minutes, 10));
    timeDateValidSince.setSeconds(parseInt(seconds, 10));
  }
  return message.replace(/%validSince%/g, formatDateTime(timeDateValidSince));
}

export function getOutageVariant(outage: IOutage, systemComponentCode: SystemComponentCode, outageState: OutageState) {
  let variant = "warning";

  if (
    [SystemComponentCode.ESHOP, SystemComponentCode.PAYGATE].includes(systemComponentCode) &&
    outageState === OutageState.ACTIVE
  ) {
    variant = "danger";
  }

  return variant;
}
